import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { FlowTypes } from '@shared/models';
import { WindowRef } from '@shared/modules/window-ref/window-ref';
import * as fromRootStore from '@store/index';
import { flowTypeSelection } from '@store/selectors/triage/triage.selectors';
import { Subscription } from 'rxjs';

import { LoggerCodes } from '../../modules/logger/constants/logger.constants';
import { LoggerService } from '../../modules/logger/service/logger.service';

declare var KAMPYLE_ONSITE_SDK: any;

@Component({
  selector: 'app-feedback-survey',
  templateUrl: './feedback-survey.component.html',
  styleUrls: ['./feedback-survey.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class FeedbackSurveyComponent implements OnInit, OnDestroy {
  subs: Subscription = new Subscription();
  surveyId: string;
  constructor(
    protected loggerService: LoggerService,
    private windowRef: WindowRef,
    private globalStore: Store<fromRootStore.State>,
  ) {}

  ngOnInit() {
    this.subs.add(
      this.globalStore.pipe(select(flowTypeSelection)).subscribe((flowType) => {
        this.surveyId =
          flowType === FlowTypes.INHERITANCE ? 'coo-inheritance-feedback' : 'coo-feedback';
      }),
    );

    setTimeout(() => {
      try {
        KAMPYLE_ONSITE_SDK.updatePageView();
      } catch (e) {
        this.loggerService.warn(
          { message: 'medallia updatePageView warning' },
          LoggerCodes.MEDALLIA_LOAD_SURVEY_FAILURE,
        );
      }
    }, 2000);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
